<template>
  <div>
    <b-modal
      id="addTeamDefinitionModal"
      :title="$t('conf.settings.team-definition.popup.add-title')"
      :ok-title="$t('shared.button.submit')"
      :cancel-title="$t('shared.button.cancel')"
      no-close-on-backdrop
      @hidden="$emit('close')"
      @ok="submitForm"
    >
      <validation-observer ref="newTeamDefinitionValidation">
        <form
          id="createTeamDefinitionForm"
          @submit.prevent
        >

          <b-row>
            <b-col
              cols="12"
              class="pb-1"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('conf.settings.team-definition.form.code')"
                rules="required|alpha-dash|min:3|max:10"
              >
                <label for="team-definition">
                  {{ $t('conf.settings.team-definition.form.code') }}
                </label>
                <b-form-input
                  id="team-definition"
                  v-model="newTeamDefinitionForm.code"
                  type="text"
                  minlength="3"
                  maxlength="10"
                  :placeholder="$t('conf.settings.team-definition.form.code')"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              class="pb-1"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('conf.settings.team-definition.form.phone')"
                rules="digits:9"
              >
                <label for="phoneNumber">
                  {{ $t('conf.settings.team-definition.form.phone') }}
                </label>
                <b-form-input
                  id="phoneNumber"
                  v-model="newTeamDefinitionForm.phoneNumber"
                  type="number"
                  minlength="9"
                  maxlength="9"
                  :placeholder="$t('conf.settings.team-definition.form.phone')"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>

            <b-col cols="12">
              <b-form-group>
                <b-form-checkbox
                  v-model="newTeamDefinitionForm.allowDriverAsParamedic"
                  :disabled="newTeamDefinitionForm.driverOnly"
                >
                  {{ $t('conf.settings.team-definition.form.allow-driver-as-paramedic') }}
                </b-form-checkbox>
                <small class="form-text text-muted">
                  {{ $t('conf.settings.team-definition.form.allow-driver-as-paramedic-help') }}
                </small>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group>
                <b-form-checkbox
                  v-model="newTeamDefinitionForm.driverOnly"
                  @change="handleDriverOnlyToggle"
                >
                  {{ $t('conf.settings.team-definition.form.driver-only') }}
                </b-form-checkbox>
                <small class="form-text text-muted">
                  {{ $t('conf.settings.team-definition.form.driver-only-help') }}
                </small>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group>
                <b-form-checkbox v-model="newTeamDefinitionForm.displayInPlanner">
                  {{ $t('conf.settings.team-definition.form.display-in-planner') }}
                </b-form-checkbox>
                <small class="form-text text-muted">
                  {{ $t('conf.settings.team-definition.form.display-in-planner-help') }}
                </small>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group>
                <b-form-checkbox v-model="newTeamDefinitionForm.acceptsFirstAvailableOrders">
                  {{ $t('conf.settings.team-definition.form.accepts-first-available-orders') }}
                </b-form-checkbox>
                <small class="form-text text-muted">
                  {{ $t('conf.settings.team-definition.form.accepts-first-available-orders-help') }}
                </small>
              </b-form-group>
            </b-col>
          </b-row>
        </form>
      </validation-observer>

    </b-modal>
  </div>
</template>

<script>
import { parseRequestError } from '@/helpers/helpers'
import {
  BCol, BFormInput, BModal, BRow,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  components: {
    BModal,
    BFormInput,
    BRow,
    BCol,

    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      newTeamDefinitionForm: this.$store.state.settings.emptyTeamDefinition,
    }
  },
  mounted() {
    this.$bvModal.show('addTeamDefinitionModal')
  },
  methods: {
    handleDriverOnlyToggle(value) {
      if (value) {
        this.$set(this.newTeamDefinitionForm, 'allowDriverAsParamedic', false)
      }
    },
    submitForm(event) {
      event.preventDefault()
      this.$refs.newTeamDefinitionValidation.validate()
        .then(valid => {
          if (!valid) {
            return false
          }

          this.$store.dispatch('settings/addTeamDefinition', this.newTeamDefinitionForm)
            .then(() => {
              this.$bvModal.hide('addTeamDefinitionModal')
              this.$emit('submitted')
              window.toast.notify.success(this.$t('conf.settings.team-definition.notify.add.success_title'))
            })
            .catch(err => parseRequestError(err))

          return true
        })
    },
  },
}
</script>
